import PropTypes from 'prop-types';
import {
  columnsModal,
  customStyles,
  opcionesdepagina,
} from '../../components/tableOptions';
import { StyledTable } from '../productosComponents';

function ItemsTable({ items, omitDate, omitCodigo, extraColumns = [],selectedRows, setSelectedRows }) {
  return (
    <StyledTable
    columnas={[...columnsModal, ...extraColumns]}
      data={items}
      omitDate={omitDate}
      omitCodigo={omitCodigo}
      customStyles={customStyles}
      pagination
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      paginationComponentOptions={opcionesdepagina}
      fixedHeader
      fixedHeaderScrollHeight='600px'
      highlightOnHover
      responsive={true}
      noDataComponent={< div > No hay informacion disponible para mostrar</div >}
    />
  );
}

ItemsTable.propTypes = {
  items: PropTypes.array,
  setSelectedRows: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  omitDate: PropTypes.bool.isRequired,
  omitCodigo: PropTypes.bool.isRequired,
  extraColumns: PropTypes.array
};

export default ItemsTable;
